import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
const START_SECONDS = 15 * 60;
const RESET_SECONDS = 10 * 60;
interface CountdownValue {
  seconds: number;
  label: string;
  expired: boolean;
}
const CountdownContext = createContext<CountdownValue>({
  seconds: START_SECONDS,
  label: '15:00',
  expired: false
});
function format(total: number): string {
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
interface CountdownProviderProps {
  children: React.ReactNode;
}
export function CountdownProvider({
  children
}: CountdownProviderProps) {
  const [seconds, setSeconds] = useState<number>(START_SECONDS);
  const [cycles, setCycles] = useState<number>(0);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          setCycles(c => c + 1);
          return RESET_SECONDS;
        }
        return prev - 1;
      });
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const value = useMemo<CountdownValue>(() => ({
    seconds,
    label: format(seconds),
    expired: cycles > 0
  }), [seconds, cycles]);
  return <CountdownContext.Provider value={value} data-id="element-122" data-mp="3owuavuj2ogcw">{children}</CountdownContext.Provider>;
}
export function useCountdown(): CountdownValue {
  return useContext(CountdownContext);
}